import { HttpClient } from '../HttpClient';
/**
 * * Get List of Locations per Company
 */
export const GetCompanyLocations = async ({ CompanyId, Id }) => {
  try {
    const { data } = await HttpClient.get(`api/companies/${CompanyId}/locations/searchCriteria`, {
      params: {
        Id,
      },
    });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
